import { useQuery } from '@tanstack/react-query';
import { getOrganization, OrganizationData } from '../firebase/organizations';

// Shared so the AuthContext prefetch and the settings-modal invalidation can
// never drift from what this hook actually reads.
export const organizationQueryKeys = {
  all: ['organization'] as const,
  byId: (organizationId?: string) => ['organization', organizationId] as const,
};

export const useOrganizationData = (organizationId?: string) => {
  return useQuery<OrganizationData | null, Error>({
    queryKey: organizationQueryKeys.byId(organizationId),
    queryFn: () => organizationId ? getOrganization(organizationId) : Promise.resolve(null),
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000, // 10 minutes - organization data doesn't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
    refetchOnMount: false, // Don't refetch if we have cached data
    refetchOnWindowFocus: false, // Don't refetch on window focus
    networkMode: 'online', // Only fetch when online
  });
};